"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-align: center;\n"], ["\n  display: inline-block;\n  text-align: center;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("../propTypes");

var _propTypes2 = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Inner = _styledComponents2.default.div(_templateObject);

var Outer = _styledComponents2.default.div(_templateObject2);

var Windmill = function Windmill() {
  return _react2.default.createElement(Outer, null, _react2.default.createElement(Inner, null, "windmill"));
};

Windmill.defaultProps = _extends({}, _propTypes.animationCommonDefaultProps, _propTypes2.windmillDefaultProps);
Windmill.propTypes = _extends({}, _propTypes.animationCommonPropTypes, _propTypes2.windmillPropTypes);
exports.default = Windmill;